import { NOISY_ERROR_MESSAGE_PATTERNS as u, OWN_BUNDLE_PATH_DEFAULT as m, STACK_FRAME_URL_RE as E, UNCAUGHT_RUM_ERROR_SOURCE as f } from "../../constants/datadogNoise.constants.js";
import { buildOpaqueErrorContext as R, isOpaqueScriptError as _ } from "../scriptErrorDiagnostics/scriptErrorDiagnostics.helper.js";
import { isbot as c } from "isbot";
var l = (r) => r.match(E) ?? [], S = ({ message: r = "", stack: e = "", source: s = f, ownOrigin: o, ownBundlePath: i = m }) => {
  if (u.some((t) => t.test(r))) return !1;
  if (s !== "source" || !o) return !0;
  const a = l(e);
  if (a.length === 0) return !0;
  const n = `${o}${i}`;
  return a.some((t) => t.startsWith(n));
}, T = ({ error: r, ...e }) => S(e) ? _({
  message: e.message,
  stack: e.stack,
  error: r
}) ? R({ ownOrigin: e.ownOrigin }) : {} : !1, d = (r) => !!r && c(r);
export {
  T as evaluateRumError,
  d as isBotUserAgent,
  S as shouldSendDatadogError
};

//# sourceMappingURL=datadogNoise.helper.js.map